import { RouteComponentProps, withRouter } from 'react-router';
import { styled } from '@mui/material/styles';
import CompanyReportWithMenus from 'kosmos/components/companyReport/CompanyReportWithMenus';

const PREFIX = 'TfpCompanyReportPage';

const classes = {
  tabHeaders: `${PREFIX}-tabHeaders`,
  tabRoot: `${PREFIX}-tabRoot`,
  tabSelected: `${PREFIX}-tabSelected`,
};

const Root = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  [`& .${classes.tabHeaders}`]: {},
  [`& .${classes.tabRoot}`]: {
    height: 70,
    fontSize: 20,
  },
  [`& .${classes.tabSelected}`]: {
    fontWeight: 'bold',
  },
}));

function TfpCompanyReportPage(props: RouteComponentProps<{ id: string }>): JSX.Element {
  const id = props.match.params.id;
  const query = new URLSearchParams(props.location.search);
  const orgId = query.get('organisationId') || undefined;
  const reportSnapshotId = query.get('reportSnapshotId') || undefined;

  if (!id) {
    return <></>;
  }
  return (
    <Root>
      <CompanyReportWithMenus organisationId={orgId} reportSnapshotId={reportSnapshotId} id={id} />
    </Root>
  );
}

export default withRouter(TfpCompanyReportPage);
